export enum DocumentTypeEnum {
    Lot = 0,
    IndividualProfile = 1,
    CompanyProfile = 2,
    Auction = 3,
}